import { observer } from "mobx-react-lite";
import { authStore } from "../../../stores/AuthStore";
import { InputAndLabelTextBox } from "@/components/input/InputAndLabelTextBox/InputAndLabelTextBox";
import { InputAndLabelPasswordBox } from "@/components/input/InputAndLabelPasswordBox/InputAndLabelPasswordBox";
import { useFormContext } from "react-hook-form";

export const Fields = observer(() => {
  const { register } = useFormContext();
  return (
    <>
      <InputAndLabelTextBox
        colorFocus="rgba(44,204,173, 1)"
        props={{
          ...register("login", {
            required: "Логин обязателен к заполнению",
            minLength: {
              value: 5,
              message: "Логин слишком короткий",
            },
          }),
          placeholder: "",
          disabled: authStore.isLoading,
          autoComplete: "current-login",
        }}
        idAndForHTML="login"
        labelText="Логин"
      />

      <InputAndLabelPasswordBox
        colorFocus="rgba(44,204,173, 1)"
        props={{
          ...register("password", { required: "Пароль обязателен к заполнению" }),
          placeholder: "",
          disabled: authStore.isLoading,
          autoComplete: "current-password",
        }}
        idAndForHTML="password"
        labelText="Пароль"
      />
    </>
  );
});
